/* eslint-disable import/no-default-export */
// eslint-disable-next-line no-restricted-imports
import { forTemplate } from 'common/lib/util/i18n';
// eslint-disable-next-line no-restricted-imports
import { AlertContainer } from 'components/alert';
// eslint-disable-next-line no-restricted-imports
import { ReactionErrorName, ReactionLimits, ReactionsAlertArea } from 'modules';
import React from 'react';

const format = forTemplate('reactions');

const ReactionAlerts: React.FunctionComponent = () => {
  return (
    <>
      <AlertContainer
        displayType="error"
        name={ReactionErrorName.ACTION_TOO_MANY_TOTAL_REACTIONS}
        area={ReactionsAlertArea}
        msTimeout={3000}
      >
        {format('total-reaction-limit-exceeded', {
          heart: '❤',
          number: ReactionLimits.perAction.toString(),
        })}
      </AlertContainer>
      <AlertContainer
        displayType="error"
        name={ReactionErrorName.ACTION_TOO_MANY_UNIQUE_REACTIONS}
        area={ReactionsAlertArea}
        msTimeout={3000}
      >
        {format('unique-reaction-limit-exceeded', {
          heart: '❤',
          number: ReactionLimits.uniquePerAction.toString(),
        })}
      </AlertContainer>
    </>
  );
};

export default ReactionAlerts;



// WEBPACK FOOTER //
// ./app/gamma/src/components/alerts/reactions-alerts/index.tsx